import React, { useCallback, useEffect, useState } from "react";

import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { Checkbox, FormControlLabel, useMediaQuery } from "@mui/material";
import { ArrowLeftIcon, ArrowRightIcon, LoaderIcon, XIcon } from "lucide-react";
import { FaTimes } from "react-icons/fa";
import { MdOutlineOpenInNew } from "react-icons/md";
import InputMask from "react-input-mask";

import { config } from "../../Config";
import { useDevice } from "../../hooks/device/useDevice";
import { listDistribuidoras, simularEconomia } from "../../page/api/simulador";
import AppButton from "../button/AppButton";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Slider } from "../ui/slider";
import ModaRedirect from "./_components/ModaRedirect";

export default function SimuladorEconomia() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const device = useDevice();

  const [openModalRedirectAquisition, setOpenModalRedirectAquisition] = useState(false);
  const [openModalRedirectLogin, setOpenModalRedirectLogin] = useState(false);
  const [openModalRedirect, setOpenModalRedirect] = useState(false);
  // const [loadingRedirect, setLoadingRedirect] = useState(false);
  const [showSimulador, setShowSimulador] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isTim, setIsTim] = useState(false);

  const [showModalNaoTemosOferta, setShowModalNaoTemosOferta] = useState(false);
  const [distribuidoraSelecionada, setDistribuidoraSelecionada] = useState("");
  const [calculoNaoFinalizado, setCalculoNaoFinalizado] = useState(false);
  const [valorEconomiaMensal, setValorEconomiaMensal] = useState(0);
  const [valorEconomiaAnual, setValorEconomiaAnual] = useState(0);
  const [impactoAmbiental, setImpactoAmbiental] = useState(0);
  const [thumbColor, setThumbColor] = useState("bg-gray-400");
  const [optComunicacao, setOptComunicacao] = useState(true);
  const [distribuidoras, setDistribuidoras] = useState([]);
  const [fingerprint, setFingerprint] = useState({});
  const [mediaGasto, setMediaGasto] = useState(0);
  const [urlParams, setUrlParams] = useState(null);
  const [telefone, setTelefone] = useState("");
  const [utm, setUtm] = useState(null);
  const [hash, setHash] = useState("");

  const isFormValid = telefone && telefone.length === 11 && distribuidoraSelecionada && mediaGasto > 0;

  useEffect(() => {
    const fetchFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();

      setFingerprint({
        idVisitor: result.visitorId,
        componentes: {
          dateTimeLocale: result.components.dateTimeLocale,
          platform: result.components.platform,
          vendor: result.components.vendor,
          vendorFlavors: result.components.vendorFlavors,
          timezone: result.components.timezone
        }
      });
    };

    fetchFingerprint();
  }, []);

  useEffect(() => {
    async function fetchDistribuidoras() {
      try {
        const response = await listDistribuidoras();
        setDistribuidoras(response.entities || []);
      } catch (error) {
        console.error("Erro ao carregar distribuidoras:", error);
      }
    }

    fetchDistribuidoras();
  }, []);

  useEffect(() => {
    const utm = {
      utmId: getQueryParams("utm_id"),
      utmSource: getQueryParams("utm_source"),
      UtmMedium: getQueryParams("utm_medium"),
      UtmCampaign: getQueryParams("utm_campaign"),
      UtmSourcePlatform: getQueryParams("utm_source_platform"),
      UtmTerm: getQueryParams("utm_term"),
      UtmContent: getQueryParams("utm_content")
    };
    setUtm(utm);
  }, []);

  useEffect(() => {
    const urlParams = `utm_source=${utm?.utmSource}&utm_medium=${utm?.UtmMedium}&utm_campaign=${utm?.UtmCampaign}&utm_id=${utm?.utmId}`;
    if (utm?.utmSource) {
      setUrlParams(urlParams);
    } else {
      setUrlParams(null);
    }
  }, [utm]);

  const getQueryParams = paramName => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(paramName);
  };

  const handleTelefoneChange = value => {
    setTelefone(value.replace(/[^0-9]/g, ""));
  };

  const handleClickLeft = () => {
    const novoValor = Math.max(mediaGasto - 50, 0);
    setMediaGasto(novoValor);
    setThumbColor("bg-main-color");
  };

  const handleClickRight = () => {
    const novoValor = Math.min(mediaGasto + 50, 2050);
    setMediaGasto(novoValor);
    setThumbColor("bg-main-color");
  };

  const handleRedirectToLogin = () => {
    const url = `${config.url.urlPortalLogin}`;
    window.location.href = url;
    setOpenModalRedirectLogin(false);
  };

  const handleSimulateEconomy = useCallback(async () => {
    try {
      if (!isFormValid) return;

      setLoading(true);
      const response = await simularEconomia({
        idDistribuidora: distribuidoraSelecionada.toString(),
        valorConsumo: mediaGasto,
        origem: 6,
        telefone,
        utm,
        fingerprintIdVisitor: fingerprint ? fingerprint.idVisitor : "",
        fingerprintComponentes: fingerprint ? fingerprint.componentes : "",
        fingerprintDevice: device,
        infoExtra: {
          optComunicacao
        }
      });

      if (response && response.entities) {
        const data = response.entities;

        if (mediaGasto < 200) {
          setShowModalNaoTemosOferta(true);
          return;
        }

        if (response?.entities?.plano === 0 && response?.entities?.mensagens !== "N/A") {
          setCalculoNaoFinalizado(true);
          setLoading(false);
          return;
        }

        if (data.isTim) {
          if (data?.situacao === "A") {
            setOpenModalRedirectLogin(true);
          }
          if (data?.situacao !== "A" && data?.situacao !== "1") {
            setOpenModalRedirectAquisition(true);
            setHash(data.hash);
          }
          setIsTim(true);
          setValorEconomiaMensal(data.mes);
          setValorEconomiaAnual(data.meses12);

          const economiaCO2 = Math.round((data.meses12 / 0.9) * 0.0385 * 100) / 100;
          const arvoresPlantadas = economiaCO2 / 22;
          setImpactoAmbiental(Math.round(arvoresPlantadas));
          setHash(data.hash);

          if (config.simulacao.situacao !== data.simulacao) {
            // lead com status diferente da simulação
          }
        } else {
          setIsTim(false);
        }

        setShowSimulador(false);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  }, [device, distribuidoraSelecionada, fingerprint, isFormValid, mediaGasto, telefone, optComunicacao, utm]);

  const handleRedirectPortal = useCallback(() => {
    if (!hash) return;
    // setLoadingRedirect(true);
    // const baseUrl = `${"http://localhost:3030/tim/aquisicao"}/${hash}`;
    const baseUrl = `${config.url.urlPortal}/${hash}`;
    const url = urlParams ? `${baseUrl}?${urlParams}` : baseUrl;
    window.location.href = url;
    // setLoadingRedirect(false);
    setOpenModalRedirect(false);
  }, [hash, urlParams]);

  useEffect(() => {
    if (!openModalRedirect) return;

    let current = 3;

    const intervalId = setInterval(() => {
      current -= 1;

      if (current === 0) {
        clearInterval(intervalId);
        handleRedirectPortal();
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [openModalRedirect, handleRedirectPortal]);

  const handleRedirectTim = () => {
    const aEl = document.createElement("a");
    aEl.href =
      "https://tim.com.br/para-voce/planos/portabilidade?_gl=1%2A1hcsr17%2A_gcl_au%2AMTQyNzQxOTcwNy4xNzM3Mzk1ODY5%2A_ga%2AMTcwMDE0Nzg2OS4xNzM3Mzk1ODcx%2A_ga_0SZQLHM90J%2AMTc0MDA1NjcwOS44LjEuMTc0MDA1ODA0MS4xNS4wLjA.&qs=portabilidade";
    aEl.target = "_blank";
    aEl.click();
  };

  const handleResetCalculadora = () => {
    setLoading(false);
    setDistribuidoraSelecionada("");
    setIsTim(false);
    setMediaGasto(0);
    setTelefone("");
    setOptComunicacao(true);
  };

  const buttonDisableClasses = "p-1 bg-gray-400 rounded-full hover:opacity-60 transition-all duration-150 ease-linear";
  const buttonEnableClasses = "p-1 bg-main-color rounded-full hover:opacity-60 transition-all duration-150 ease-linear";

  const enableLeftButton = mediaGasto > 0;
  const enableRightButton = mediaGasto < 2050;

  const setCookie = (name, value, days) => {
    if (!name || !value) return;
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; domain=.thopenergy.com.br";
  };

  return (
    <div className='w-full lg:w-[35rem] rounded-3xl bg-white p-10 max-sm:px-4'>
      {showSimulador ? (
        <div id='boxSimulador' className='flex flex-col gap-6 justify-center items-center'>
          <h4 className='italic text-center text-neutral-900 text-3xl font-bold'>Simule sua economia</h4>

          <div className='w-full space-y-2'>
            <Label
              htmlFor='distribuidora'
              className='w-full flex justify-start text-center text-base font-semibold leading-normal pb-2'
            >
              DDD + Número celular TIM
            </Label>
            <InputMask
              className='flex h-12 w-full items-center justify-between whitespace-nowrap text-gray-500 rounded-2xl border border-input border-black bg-transparent px-4 py-7 text-lg shadow-sm placeholder:text-muted-foreground focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1'
              mask='(99) 99999-9999'
              placeholder='Digite aqui seu celular com DDD'
              type='tel'
              name='celular'
              id='celular'
              required
              autoComplete='off'
              autoCorrect='off'
              autoCapitalize='off'
              spellCheck='false'
              value={telefone}
              onChange={e => {
                const cleanValue = e.target.value.replace(/[^0-9]/g, "");
                const userId = cleanValue ? `tim_${e.target.value?.replace(/[^0-9]/g, "")}` : null;
                localStorage.setItem("user_id", userId);
                setCookie("timthopenergyuserid", userId, 365);
                handleTelefoneChange(e.target.value);
              }}
            />
          </div>

          <div className='w-full space-y-2'>
            <Label
              htmlFor='distribuidora'
              className='w-full flex justify-start text-center text-base font-semibold leading-normal pb-2'
            >
              Distribuidora
            </Label>
            <Select
              onValueChange={async value => {
                setDistribuidoraSelecionada(value);
              }}
              value={distribuidoraSelecionada}
              name='distribuidora'
            >
              <SelectTrigger className='w-full '>
                <SelectValue placeholder='Selecione uma opção' />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {distribuidoras.map((distribuidora, index) => (
                    <SelectItem key={index} value={distribuidora?.idDistribuidora}>
                      {distribuidora?.nomeDistribuidora || "Distribuidora"}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <p className="text-center text-neutral-600 text-lg font-normal font-['Roboto'] leading-[27px]">
            Média de gasto da sua conta
          </p>
          <div className='w-full flex justify-center items-center gap-3'>
            <button
              className={enableLeftButton ? buttonEnableClasses : buttonDisableClasses}
              onClick={handleClickLeft}
              disabled={!enableLeftButton}
              aria-label='Voltar'
            >
              <ArrowLeftIcon size={12} className='text-white max-md:size-8' />
            </button>
            <Slider
              value={[mediaGasto]}
              onValueChange={value => {
                const novoValor = value[0];
                setMediaGasto(novoValor);
                setThumbColor("bg-main-color");
              }}
              max={2050}
              min={0}
              step={50}
              thumbValue={mediaGasto}
              thumbColor={thumbColor}
              className='w-[80%]'
              endText='+ de R$ 2.000,00'
            />
            <button
              className={enableRightButton ? buttonEnableClasses : buttonDisableClasses}
              onClick={handleClickRight}
              disabled={!enableRightButton}
              aria-label='Avançar'
            >
              <ArrowRightIcon size={12} className='text-white max-md:size-8' />
            </button>
          </div>
          <div className='w-full flex justify-between items-center gap-2 px-5'>
            <div className="text-center text-gray-500 text-sm font-normal font-['Roboto']">R$ 0,00</div>
            <div className="text-center text-gray-500 text-sm font-normal font-['Roboto']">R$ 2.000,00 ou +</div>
          </div>

          <div>
            <FormControlLabel
              control={<Checkbox onChange={e => setOptComunicacao(e.target.checked)} checked={optComunicacao} />}
              label={
                <div className='justify-center text-black text-sm font-normal'>
                  Aceito receber comunicações da Thopen-TIM
                </div>
              }
            />
          </div>
          <div className='w-full'>
            <Button
              id='botao-submit'
              variant='primary'
              size='lg'
              disabled={!isFormValid || loading || !optComunicacao}
              onClick={handleSimulateEconomy}
            >
              {loading ? (
                <>
                  <LoaderIcon size={18} className='mr-2 animate-spin text-white' />
                  Calculando
                </>
              ) : (
                "Economize já"
              )}
            </Button>
          </div>
        </div>
      ) : (
        <div id='boxResposta' className='flex flex-col gap-6 justify-center items-center'>
          {isTim && (
            <>
              <div className='w-full flex flex-col justify-center items-center gap-7 my-4'>
                <h4 className='text-center font-bold text-neutral-900 text-3xl leading-[52.80px] mb-2'>Resultado</h4>

                <div className='w-full flex flex-col justify-center items-center space-y-2'>
                  <p className='font-bold text-3xl md:text-4xl text-color-black'>
                    {valorEconomiaAnual.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    })}
                  </p>
                  <p>Economia estimada anual</p>
                </div>

                <div className='w-full flex flex-col justify-center items-center space-y-2'>
                  <p className='font-bold text-3xl md:text-4xl text-color-black'>
                    {valorEconomiaMensal.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL"
                    })}
                  </p>
                  <p>Economia estimada mensal</p>
                </div>

                <div className='w-full flex flex-col justify-center items-center space-y-2'>
                  <p className='font-bold text-3xl md:text-4xl text-color-black'>{impactoAmbiental}</p>
                  <p>{impactoAmbiental === 1 ? "Árvore plantada por mês" : "Árvores plantadas por mês"}</p>
                </div>
              </div>

              <div className='w-full h-px border-b border-gray-200 my-4' />

              <div className='w-full flex max-md:flex-wrap gap-4 items-center justify-center'>
                <AppButton
                  fullWidth
                  variantAcquisition
                  textButton='Economize já'
                  onClick={() => setOpenModalRedirect(true)}
                  id='click_submit'
                />
                <AppButton
                  fullWidth
                  blueVariantborder
                  textButton='Refazer simulação'
                  onClick={() => setShowSimulador(true)}
                  id='refazer_simulacao'
                />
              </div>
            </>
          )}
          {!isTim && (
            <>
              <div className='w-full flex flex-wrap gap-4 items-center justify-center'>
                <div className='w-full flex flex-col justify-center items-center gap-8'>
                  <div className='w-[35px] h-[30px] overflow-hidden'>
                    <img
                      src='/tim/images/logos/logo-tim.png'
                      alt='Logo TIM'
                      className='w-auto h-full object-cover object-left'
                    />
                  </div>
                  <p className='font-bold text-[24px] text-color-black'>
                    Você pode migrar seu número para a TIM! Ganhe 30GB para testar a rede TIM. É grátis e fácil!
                  </p>
                  <p className='text-secondary-text'>Apenas clientes TIM tem elegibilidade para esse benefício.</p>
                  <div className='w-full flex flex-col gap-4 items-center justify-center'>
                    <AppButton
                      fullWidth
                      blueVariantborder
                      textButton='Refazer simulação'
                      onClick={() => setShowSimulador(true)}
                      id='refazer_simulacao_nao_tim'
                    />
                    <AppButton
                      fullWidth
                      variantAcquisition
                      textButton='Eu quero'
                      id='nao_elegivel_tim'
                      onClick={() => handleRedirectTim()}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {/* Modal para redirecionamento caso o usuário tenha abandonado/caído da aquisição */}
      <ModaRedirect
        isOpen={openModalRedirectAquisition}
        onClose={() => {
          setOpenModalRedirectAquisition(false);
          setShowSimulador(true);
          setIsTim(false);
        }}
      >
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <button
              className='absolute top-4 right-4 text-black'
              onClick={() => {
                setOpenModalRedirectAquisition(false);
                setShowSimulador(true);
                setIsTim(false);
              }}
              type='button'
              aria-label='Close modal'
            >
              <FaTimes className='w-6 h-6' />
            </button>
            <MdOutlineOpenInNew size={50} color='red' />
            <p className='text-xl text-center font-medium px-4 mt-3 mb-10'>
              Bem-vindo de volta. Vamos redirecioná-lo para a página onde você parou.
            </p>
            <div className='w-full flex justify-center'>
              <AppButton modalVariant fullWidth textButton='Entendi' onClick={() => handleRedirectPortal()} />
            </div>
          </div>
        </div>
      </ModaRedirect>

      {/* Modal para redirecionamento caso o usuário já tenha finalizado a aquisição */}
      <ModaRedirect
        isOpen={openModalRedirectLogin}
        onClose={() => {
          setOpenModalRedirectLogin(false);
          setShowSimulador(true);
          setIsTim(false);
        }}
      >
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <button
              className='absolute top-4 right-4 text-black'
              onClick={() => {
                setOpenModalRedirectLogin(false);
                setShowSimulador(true);
                setIsTim(false);
              }}
              type='button'
              aria-label='Close modal'
            >
              <FaTimes className='w-6 h-6' />
            </button>
            <MdOutlineOpenInNew size={50} color='red' />
            <p className='text-xl text-center font-medium px-4 mt-3 mb-10'>
              Você já está cadastrado. Vamos redirecioná-lo para fazer sua identificação.
            </p>
            <div className='w-full flex justify-center'>
              <AppButton
                modalVariant
                fullWidth={isMobile}
                textButton='Entendi'
                onClick={() => handleRedirectToLogin()}
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

      {/* Modal de não temos uma oferta */}
      <ModaRedirect isOpen={showModalNaoTemosOferta}>
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <XIcon size={50} className='text-red-500' />
            <p className='text-xl text-center font-medium px-4 mt-3'>Ainda não temos uma oferta para você.</p>
            <p className='text-base text-center px-4 my-5'>
              O benefício não está disponível para o seu perfil mensal de consumo. Entraremos em contato assim que
              tivermos uma oportunidade.
            </p>
            <div className='w-full flex flex-col justify-center items-center gap-4'>
              <AppButton
                fullWidth
                type='button'
                textButton='Entendi'
                onClick={() => {
                  const aEl = document.createElement("a");
                  aEl.href = config.url.urlSiteThopen;
                  aEl.target = "_blank";
                  aEl.click();
                  setShowModalNaoTemosOferta(false);
                  handleResetCalculadora();
                }}
              />
              <AppButton
                fullWidth
                secondary
                type='button'
                textButton='Refazer simulação'
                onClick={() => {
                  setShowModalNaoTemosOferta(false);
                  handleResetCalculadora();
                }}
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

      {/* Modal de calculo não finalizado */}
      <ModaRedirect
        isOpen={calculoNaoFinalizado}
        onClose={() => {
          setCalculoNaoFinalizado(false);
          setDistribuidoraSelecionada("");
          setMediaGasto(0);
          setTelefone("");
          setOptComunicacao(true);
        }}
      >
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <button
              className='absolute top-4 right-4 text-black'
              onClick={() => {
                setCalculoNaoFinalizado(false);
                setDistribuidoraSelecionada("");
                setMediaGasto(0);
                setTelefone("");
                setOptComunicacao(true);
              }}
              type='button'
              aria-label='Close modal'
            >
              <FaTimes className='w-6 h-6' />
            </button>
            <XIcon size={50} className='text-red-500' />
            <p className='text-xl text-center font-medium px-4 mt-3'>Não foi possível realizar a sua simulação.</p>
            <p className='text-base text-center px-4 my-5'>Tente acessar mais tarde</p>

            <div className='w-full flex justify-center'>
              <AppButton
                fullWidth={isMobile}
                textButton='Entendi'
                onClick={() => {
                  setCalculoNaoFinalizado(false);
                  setDistribuidoraSelecionada("");
                  setMediaGasto(0);
                  setTelefone("");
                  setOptComunicacao(true);
                }}
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

      {/* Modal para redirecionamento para o portal do parceiro */}
      <ModaRedirect isOpen={openModalRedirect} onClose={() => setOpenModalRedirect(false)}>
        <div className='flex flex-col h-[100vh] items-start justify-end md:justify-center'>
          <div className='relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6'>
            <button
              className='absolute top-4 right-4 text-black'
              onClick={() => setOpenModalRedirect(false)}
              aria-label='Close modal'
            >
              <FaTimes className='w-6 h-6' />
            </button>
            <MdOutlineOpenInNew size={50} color='red' />
            <p className='text-xl text-center font-medium px-4 mt-3 mb-10'>
              Você será direcionado para o portal do nosso parceiro Thopen.
            </p>
            {/* <div className='w-full flex justify-center'>
              <AppButton
                modalVariant
                fullWidth
                textButton={loadingRedirect ? 'Carregando...' : 'Entendi'}
                onClick={() => handleRedirectPortal()}
              />
            </div> */}
          </div>
        </div>
      </ModaRedirect>
    </div>
  );
}